import styled from 'styled-components'
import { media } from '../../utils'

export const FooterWrap = styled.div`
  padding: 30px;
  background-color: #a6c9cd;
  font-size: 15px;

  ${media.tablet`
    padding-bottom: 120px;
  `}

  ${media.largePhone`
    padding-left: 15px;
    padding-right: 15px;
  `}
`

export const LinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;

  a {
    padding: 0 7.5px;
    border-left: 1px solid #4a4a4a;
    color: #4a4a4a;
  }
  a:first-child {
    border: none;
  }

  a:hover {
    color: unset;
    text-decoration: underline;
  }

  ${media.largePhone`
    flex-direction: column;
    a {
      margin: 7.5px 0;
      padding: 0;
      border: none;
      border-bottom: 1px solid #4a4a4a;
    }
    a:last-hild {
      border: none;
    }
    a:first-child {
      border-bottom: 1px solid #4a4a4a;
    }
  `}
`

export const Line = styled.div`
  display: block;
  max-width: 1200px;
  margin: 3px auto;
  text-align: center;
  ${media.largePhone`
    margin-top: 7.5px;
  `}
`



// WEBPACK FOOTER //
// ./src/components/layout/FooterStyle.js